module.exports = __webpack_public_path__ + "5a45036c087ff05a59188b4ca9a2a1a5.jpg";